<template>
  <div tabindex="-1"  @keydown.stop.left="onKeyLeft" @keydown.stop.right="onKeyRight" class="line-detail elevation-0" >            
    <v-layout column>      
        <template v-if="mission._detailLoaded">                                      
          <mission-range-time-line :uiid="uiid" v-if="showTimeRange" :mission="mission" :updateOnMove="isGlobal" :endMissionMode="endMissionMode" />                   
          <mission-time-line :uiid="uiid" v-if="showTimeRange" :mission="mission" :endMissionMode="endMissionMode" />          
          <template v-if="yo && canRender">                           
            <div v-if="yo.isUnderWater">     
              <hr/>         
              <strong>{{$t('Pilot.MissionDrawer.Cycle')}} {{yo.yosCycle}} :</strong> {{$t('Pilot.MissionDrawer.UndewaterInfos')}} 
            </div>
            <div  v-else>
            <hr/>                
            <template>
                <h2 class="body-2" :class="{'secondary--text':endMissionMode}">{{$t('Pilot.MissionDrawer.MRS')}}</h2>
                <table class="mrs-tbl" cellspacing="0">
                  <thead>
                    <tr>          
                      <td>{{$t('Pilot.MissionDrawer.Cycle')}}</td>
                      <td>{{$t('Pilot.MissionDrawer.Battery')}}</td>          
                      <td>{{$t('Pilot.MissionDrawer.Date')}}</td>          
                      <td>{{$t('Pilot.MissionDrawer.Time')}}</td>
                      <td>{{$t('Pilot.MissionDrawer.Latitude')}}</td>
                      <td>{{$t('Pilot.MissionDrawer.Longitude')}}</td>
                    </tr>
                  </thead>
                  <tr>          
                      <td>{{yo.yosCycle}}</td>
                      <td>{{yo.batteries}} %</td>          
                      <td>{{yo.yoGpsDatTime | formatDate('DD/MM/YYYY')}}</td>
                      <td>{{yo.yoGpsDatTime | formatDate('HH:mm:ss UTC')}}</td>
                      <td>{{$options.filters[coordFormatFilter]([yo.yoGpsLon,yo.yoGpsLat],true)}}</td>
                      <td>{{$options.filters[coordFormatFilter]([yo.yoGpsLon,yo.yoGpsLat],false)}}</td>          
                    </tr>
                </table>   
              </template>
              <template>
              <!-- <h2 class="body-2">{{$t('Pilot.MissionDrawer.Nav')}}</h2>  
              <table class="mrs-tbl" cellspacing="0">
                <thead>
                  <tr>          
                    <td>{{$t('Pilot.MissionDrawer.Heading')}} [°]</td>
                    <td>{{$t('Pilot.MissionDrawer.Zb')}} [m]</td>
                    <td>{{$t('Pilot.MissionDrawer.Zt')}} [m]</td>
                    <td>{{$t('Pilot.MissionDrawer.Altitude')}} [m]</td>
                    <td>{{$t('Pilot.MissionDrawer.PU')}} [mm]</td>
                    <td>{{$t('Pilot.MissionDrawer.PD')}} [mm]</td>
                    <td>{{$t('Pilot.MissionDrawer.BU')}} [ml]</td>
                    <td>{{$t('Pilot.MissionDrawer.BD')}} [ml]</td>
                    <td>{{$t('Pilot.MissionDrawer.Rate')}}</td>
                  </tr>
                </thead>
                <tr>
                    <td>{{yo.heading}}</td>
                    <td>{{yo.zb}}</td>
                    <td>{{yo.zt}}</td>
                    <td>{{yo.alt}}</td>
                    <td>{{yo.pu}}</td>
                    <td>{{yo.pd}}</td>
                    <td>{{yo.bu}}</td>
                    <td>{{yo.bd}}</td>
                    <td>{{yo.rate}}</td>          
                  </tr>
              </table>  -->
            </template>   
              <template v-if="!hasComputedNmea">
                <h2 class="body-2" :class="{'secondary--text':endMissionMode}">{{$t('Pilot.MissionDrawer.Computed')}}</h2>
                <table class="mrs-tbl" cellspacing="0">
                  <thead>
                    <tr>          
                      <td>{{$t('Pilot.MissionDrawer.Distance')}} [m]</td>
                      <td>{{$t('Pilot.MissionDrawer.FlightTime')}} [h:m]</td>
                      <td>{{$t('Pilot.MissionDrawer.COG')}} [°]</td>
                      <td>{{$t('Pilot.MissionDrawer.SOG')}} [m/s]</td>
                      <td>{{$t('Pilot.MissionDrawer.Drift')}} [°]</td>                    
                      <td>{{$t('Pilot.MissionDrawer.MissionDuration')}}</td>
                    </tr>
                  </thead>
                  <tr>
                      <td>{{computedDistance}}</td>
                      <td>{{computedFlightTime}}</td>
                      <td>{{computedCog}}</td>
                      <td>{{computedSog}}</td>
                      <td>{{computedDrift}}</td>
                      <td>{{[mission.yoArray[0].yoGpsDatTime,yo.yoGpsDatTime] | formatDuree($i18n)}}</td>
                    </tr>
                </table>  
              </template>                     
              <template v-for="nmeaInit in nmeasInit">
                <div v-if="nmeaInit.name == 'computed'" :key="nmeaInit.name">
                  <h2 class="body-2" :class="{'secondary--text':endMissionMode}" >{{$t('Pilot.MissionDrawer.Computed')}}</h2>                     
                  <table class="mrs-tbl" cellspacing="0"  v-if="nmeaInit.col1.length > 0">
                    <thead>
                      <tr>          
                        <td v-for="col in nmeaInit.col1" :key="`th_${col.name}`">{{$i18n.locale == 'fr'?col.libelleFr||col.libelleEn:col.libelleEn||col.libelleFr}} <template v-if="col.unit.length > 0">[{{col.unit}}]</template></td>            
                      </tr>
                    </thead>
                    <tr>          
                        <td v-for="col in nmeaInit.col1" :key="`td_${col.name}`">{{computedFromName(col.name)}}</td>        
                    </tr>
                  </table> 
                  <table class="mrs-tbl mt-1" cellspacing="0"  v-if="nmeaInit.col2.length > 0">
                    <thead>
                      <tr>          
                        <td v-for="col in nmeaInit.col2" :key="`th_${col.name}`">{{$i18n.locale == 'fr'?col.libelleFr||col.libelleEn:col.libelleEn||col.libelleFr}} <template v-if="col.unit.length > 0">[{{col.unit}}]</template></td>            
                      </tr>
                    </thead>
                    <tr>          
                        <td v-for="col in nmeaInit.col2" :key="`td_${col.name}`">{{computedFromName(col.name)}}</td>        
                    </tr>
                  </table> 
                  <table class="mrs-tbl mt-1" cellspacing="0"  v-if="nmeaInit.col3.length > 0">
                    <thead>
                      <tr>          
                        <td v-for="col in nmeaInit.col3" :key="`th_${col.name}`">{{$i18n.locale == 'fr'?col.libelleFr||col.libelleEn:col.libelleEn||col.libelleFr}} <template v-if="col.unit.length > 0">[{{col.unit}}]</template></td>            
                      </tr>
                    </thead>
                    <tr>          
                        <td v-for="col in nmeaInit.col3" :key="`td_${col.name}`">{{computedFromName(col.name)}}</td>        
                    </tr>
                  </table>                                 
                </div>                
              </template>                                         
            </div> 
          </template>
        </template>    
        <template  v-else>
          {{$t("Pilot.MissionDrawer.Loading")}}
          <v-progress-linear indeterminate :color="endMissionMode?'secondary':'primary'"  ></v-progress-linear>      
        </template>                
    </v-layout>    
  </div>  
</template>
<script>  
  import { mapGetters } from 'vuex'  
  import MissionTimeLine from '@/components/mission/MissionTimeLine'
  import MissionRangeTimeLine from '@/components/mission/MissionRangeTimeLine'  
  import MissionColor from '@/components/mission/MissionColor'  
  import { AloMission } from '@/models/alo/AloMission'  
  import {stylesList, defaultMapStyle} from '@/components/map/MapStyles'    
  import bearing from '@turf/bearing'
  import distance from '@turf/distance'
  import {point,bearingToAzimuth} from '@turf/helpers'
  import MissionSurfacage from '@/components/mission/MissionSurfacage'  
  import MissionNmeaDetail from '@/components/mission/MissionNmeaDetail'
  import { SecurityItemsKeys } from '../../enum/SecurityItems'
  import {posModulo} from  '@/utils/modulo'
  import { NmeasConfig } from '@/models/datapool/NmeasConfig'
  import { DataPoolGlobalKeys } from '@/enum/DataPool'
  import {getSimulationStatusTradKey,SimulationStatus} from '@/enum/SimulationStatus'  
  import mission from '@/api/mission'

  export default {
    name: 'MissionSimulationLineDetail',
    props:{
      mission:{
        type: AloMission
      },
      uiid:{
          type: String,
          required: true
      },
      showTimeRange:{
        type: Boolean,
        default: true
      },
      shownav:{
          type: Boolean,
          default: false
      },
      endMissionMode:{
        type: Boolean,
        default: false
      }
      
    },
    data(){
      return {
        showClosMissionDialog:false,        
        nmeasConfig: new NmeasConfig(),
        nmeaLoading:{},
        canRender:true
      }
    },   
    components:{MissionTimeLine,MissionRangeTimeLine,MissionSurfacage,MissionColor,MissionNmeaDetail},          
    created(){
      this.$options.stylesList = stylesList
      this.$options.defaultMapStyle = defaultMapStyle     
      
      this.$store.myActions.DATAPOOL_ENSURE({fullKey:DataPoolGlobalKeys['global.config.nmea']}).then(()=>{
        this.nmeasConfig = NmeasConfig.createNmeasConfig(this.originalNmeaConfigStr)          
      })            
    },    
    mounted(){
      this.checkSimulationProgress();      
    },
    computed:{
      ...mapGetters([
        'uistatebyuiid',            
        'coordFormatFilter',        
        'currentMissionMapId'
      ]),                    
      missionState() {          
        //retourne un MissionUiState            
        return this.uistatebyuiid(this.uiid)
      },
      hasComputedNmea()
      {
        return (this.nmeasInit?.findIndex(r => r.name.toLowerCase() == "computed") ?? -1)  > -1
      },
      isGlobal() {
        return this.missionState?.typeUiid == 'global'
      },                           
      yo(){           
        return this.mission.yoArray[this.yoIndex]
      },
      yoCycle(){           
        return this.mission.yoArray[this.yoIndex]?.yosCycle
      },
      yoIndex(){
        return this.missionState && this.missionState.timelineIndex != -1?this.missionState.timelineIndex:(this.mission.yoArray.length-1)
      },
      nextYo() {            
        let yo = null        
        if(this.missionState && this.missionState.timelineIndex != -1) {
          let idx = 1
          while(this.mission.yoArray.length > (this.missionState.timelineIndex+idx) &&  (yo = this.mission.yoArray[this.missionState.timelineIndex+idx]).isUnderWater){
            idx++;
          }        
          if(yo && !yo.isUnderWater) return yo.driftArray[0] || yo          
        }
        return null
      },
      canComputeCoord(){
        return this.nextYo && this.nextYo.yoGpsLon && this.nextYo.yoGpsLat && this.yo && this.yo.yoGpsLon && this.yo.yoGpsLat
      },
      computedDistance() {        
        if(this.canComputeCoord) {             
          return (distance(point([this.yo.yoGpsLon, this.yo.yoGpsLat]),point([this.nextYo.yoGpsLon, this.nextYo.yoGpsLat])) * 1000).toFixed(0)
        }
        else{
          return '-'
        }
      },
      computedFlightTime() {                
        if(this.nextYo) {             
          return this.$options.filters.formatDuree([this.yo.yoGpsDatTime,this.nextYo.yoGpsDatTime],this.$i18n)
        }
        else{
          return '-'
        }
      },
      computedCog(){
        if(this.canComputeCoord) {
          return bearingToAzimuth(bearing(point([this.yo.yoGpsLon, this.yo.yoGpsLat]),point([this.nextYo.yoGpsLon, this.nextYo.yoGpsLat]))).toFixed(2)
        }
        else{
          return '-'
        }
      },
      computedDrift() {
        if(this.canComputeCoord && this.yo.heading != -9999) {          
          return (posModulo( this.computedCog -  this.yo.heading + 180,360) - 180).toFixed(2)
        }
        else{
          return '-'
        }
      },
      computedSog(){
        if(this.canComputeCoord) {
          return (this.computedDistance / ((this.nextYo.yoGpsDatTime.getTime() -  this.yo.yoGpsDatTime.getTime())/1000)).toFixed(2)
        }
        else{
          return '-'
        }
      },      
      originalNmeaConfigStr() {        
        return  (this.$store.myGetters.dataPoolItemsValueByKey(DataPoolGlobalKeys['global.config.nmea']) || "").split('\n')
      },
      nmeasInit(){
        return this.nmeasConfig.rowInit.filter(r => r.name.toLowerCase() == "computed")
      },
      missionRefresh(){
        return this.mission._refresh
      }      
    },    
    watch:{
      originalNmeaConfigStr(newValue) {
        this.nmeasConfig = NmeasConfig.createNmeasConfig(this.originalNmeaConfigStr)
      },      
      missionRefresh() {        
        this.canRender = false
        this.$nextTick(()=> this.canRender = true)
      },
      uiid(){
        this.checkSimulationProgress()
      }
    },
    methods:{
      checkSimulationProgress(){
        if(this.mission.hasEndMissionSimulation) {
          if(!(this.mission.simulation?._detailLoaded ?? false)) {
            this.$store.myActions.MISSIONVIRTUAL_PROGRESSION_REQUEST(this.mission.misId)
          }
        }
      },      
      computedFromName(name){
        switch(name){
          case "distance": return this.computedDistance
          case "flight_time": return this.computedFlightTime
          case "cog": return this.computedCog
          case "sog": return this.computedSog
          case "drift": return this.computedDrift
          case "mission_duration": return this.$options.filters.formatDuree([this.mission.yoArray[0].yoGpsDatTime,this.yo.yoGpsDatTime],this.$i18n)
          default: return "-"          
        }
      },
      onKeyRight(){                                      
        const index = this.missionState.timelineIndex != -1? this.missionState.timelineIndex : this.mission.yoArray.length - 1
        if(index < (this.mission.yoArray.length - 1)) {            
          this.$store.myActions.UI_SELECT_TIMELINE_MISSION_INDEX({index:index+1, uiid:this.uiid})                                  
        }        
      },
      onKeyLeft(){                
        const index = this.missionState.timelineIndex != -1? this.missionState.timelineIndex : this.mission.yoArray.length - 1
        if(index > 0) {            
          this.$store.myActions.UI_SELECT_TIMELINE_MISSION_INDEX({index:index-1, uiid:this.uiid})                                  
        }        
      },
      endMission() {
        
      }    
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2{
  color: var(--primary-color)  
}
</style>
<style>

.mrs-tbl{
  width: 100%;
  font-size: 0.8rem;
}

.cursor-pointer{
  cursor: pointer;
}

table{
  border: 1px solid #ddd;
  border-bottom:0px;
  border-right:0px;    
  max-width: 100%; 
  overflow: auto;
}
thead{
  font-weight: bold;
}
td{
  padding: 0px 2px;
  border:1px solid #ddd;
  border-top:0px;
  border-left:0px;  
  text-align: center;
} 


.line-item .active{
  color: #4caf50!important;
}

.line-item .heading{
  display: flex;
  flex-direction: row;
  align-items: center;  
}
.White>div{
  border: solid 2px #000!important;
}

.line-detail:focus{
    outline: none;
}

.line-detail{
  /*correct elevation bug*/
  -webkit-box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)!important;
  box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)!important;
}
</style>
